import React, { useState, useCallback, useRef } from 'react';
import moment from 'moment';
import Contents from '../../../contents/index';
import axios from 'axios';
import ModalContentBase from '../../components/modal/modal_content_base';
import Loader from '../../../../components/loader.jsx';
import BlogTagsInput from './tags_input';
import compressImage from '../../../../lib/image_compressor.js';

const Edit = ({
  blog,
  myCircle,
  blogTags,
  pastTags,
  isApp,
  imageUrlMedium,
  pdfUrl,
  userAgent,
}) => {
  const [title, setTitle] = useState(blog.title);
  const [image, setImage] = useState(imageUrlMedium);
  const [publishDatetime, setPublishDatetime] = useState(
    moment(blog.publish_datetime).format('YYYY-MM-DDTHH:mm:ss')
  );
  const [publicType, setPublicType] = useState(blog.public_type);
  const [isDraft, setIsDraft] = useState(blog.is_draft);
  const [isDeleted, setIsDeleted] = useState(false);
  const [tags, setTags] = useState(blogTags || []);
  const [eventId, setEventId] = useState(blog.event_id);
  const [uploading, setUploading] = useState(false);
  const [pdfUploading, setPdfUploading] = useState(false);
  const [pdf, setPdf] = useState(pdfUrl);

  const inputRef = useRef(null);

  const updateImage = useCallback(
    async (photoFile) => {
      const compressedFile = await compressImage(photoFile);
      setUploading(true);
      let formData = new FormData();
      formData.append('file', compressedFile);
      axios
        .patch(`/api/my_circle/blog/${blog.id}/update_image`, formData)
        .then((response) => {
          setImage(response.data.image_url_medium);
        })
        .catch(() => {})
        .finally(() => {
          setUploading(false);
        });
    },
    [blog]
  );

  const updateBlogToServer = (status, boolean) => {
    $.ajax({
      url: '/api/my_circle/blog/update',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        id: blog.id,
        event_id: eventId,
        title: title,
        content: '',
        publish_datetime: publishDatetime,
        public_type: publicType,
        is_draft: status === 'draft' ? boolean : isDraft,
        is_deleted: status === 'delete' ? boolean : isDeleted,
        tags: tags.join(' '),
      },
    })
      .done(() => {
        window.location.href = `/my_circle/${myCircle.id}/blogs/`;
      })
      .fail(() => {});
  };

  const handleTitleInput = (e) => {
    setTitle(e.target.value);
  };

  const handleTagClick = (tag) => {
    if (!tags.includes(tag)) {
      const updatedTags = [...tags, tag];
      setTags(updatedTags);
    }
  };

  const handleTagsInput = (updatedTags) => {
    setTags(updatedTags);
  };

  const handleDraftButton = () => {
    var result = window.confirm('下書きで保存しますか？');
    if (result) {
      updateBlogToServer('draft', true);
    }
  };

  const handleDeleteButton = () => {
    var result = window.confirm('このブログを削除しますか？');
    if (result) {
      updateBlogToServer('delete', true);
    }
  };

  const handleSubmitButton = () => {
    var result = window.confirm('作成しますか?');
    if (result) {
      updateBlogToServer('draft', false);
    }
  };

  const handlePostDateChange = (e) => {
    setPublishDatetime(e.target.value);
  };

  const handleKeydown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.target.blur();
    }
  };

  const updatePdf = useCallback(
    (e) => {
      setPdfUploading(true);

      if (e.target.files.length === 0) {
        setPdfUploading(false);
        return;
      }
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      axios
        .patch(`/api/my_circle/blog/${blog.id}/update_pdf`, formData)
        .then((response) => {
          setPdf(response.data.pdf_url);
        })
        .catch(() => {})
        .finally(() => {
          setPdfUploading(false);
          // ファイル入力をリセット
          e.target.value = null;
        });
    },
    [blog]
  );

  const deletePdf = useCallback(() => {
    if (!pdf) return;
    if (confirm('PDFを削除しますか？')) {
      axios
        .post(`/api/my_circle/blog/${blog.id}/delete_pdf`)
        .then(() => {
          setPdf(null);
        })
        .catch(() => {});
    }
  }, [pdf, blog]);

  return (
    <div className="">
      <div
        className="bg-white py-3"
        style={{
          position: 'sticky',
          top: userAgent == 'pc' ? '6%' : isApp ? '0%' : '8%',
          zIndex: '20',
        }}
      >
        <div className="container col-md-8">
          <div className="row align-items-center">
            <div className="col-3" />
            <div className="col-9 d-flex justify-content-end">
              <div className="">
                <ModalContentBase
                  previewContent={previewContent}
                  modalContent={
                    <DetailContent
                      publicType={publicType}
                      publishDatetime={publishDatetime}
                      tags={tags}
                      setPublicType={setPublicType}
                      handlePostDateChange={handlePostDateChange}
                      handleTagClick={handleTagClick}
                      handleTagsInput={handleTagsInput}
                      handleDeleteButton={handleDeleteButton}
                      myCircle={myCircle}
                      pastTags={pastTags}
                    />
                  }
                />
              </div>
              <button
                type="button"
                className="text-fz-13px text-fw-500 p-0 m-0 mr-2 a-button__top a-button__top--outline"
                style={{ height: '35px', width: '100px' }}
                onClick={handleDraftButton}
              >
                下書き
              </button>
              <button
                type="button"
                onClick={handleSubmitButton}
                className="text-fz-13px text-fw-500 btn a-button__top a-button--orange text-white m-0"
                style={{ height: '35px', width: '100px' }}
              >
                作成
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-5" />
      <div className="container col-lg-8">
        <figure style={{ position: 'relative' }}>
          <label htmlFor="image_data" className="w-100">
            {uploading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '400px', width: '100%' }}
              >
                <Loader isActive={true} />
              </div>
            ) : image ? (
              <img
                src={image}
                alt=""
                style={{
                  height: '400px',
                  // width: '100%',
                  objectFit: 'contain',
                  cursor: 'pointer',
                }}
              />
            ) : (
              <span className="d-block text-black-20 text-fz-small">
                <img
                  src="/assets2019/image.svg"
                  alt=""
                  className="cursor-pointer logo-img-circle bg-graydark"
                  style={{ width: '70px', height: '70px' }}
                />
              </span>
            )}
            <input
              type="file"
              accept="image/png, image/jpeg, image/heic, image/heif, .heic, .heif"
              onChange={(e) => {
                updateImage(e.target.files[0]);
              }}
              id="image_data"
              style={{ display: 'none' }}
            />
          </label>
        </figure>
      </div>
      <div className="container col-lg-8">
        <textarea
          type="text"
          className="textarea-no-border bg-white"
          placeholder="ブログタイトル"
          value={title}
          onKeyDown={(e) => handleKeydown(e)}
          onChange={handleTitleInput}
        />
        {pdf ? (
          <div className="text-fz-20px text-fw-bold">
            <span
              style={{ color: '#48A3E9', cursor: 'pointer' }}
              onClick={() => {
                inputRef.current && inputRef.current.click();
              }}
            >
              PDFを変更
            </span>
            <span
              className="text-danger ml-4"
              style={{ cursor: 'pointer' }}
              onClick={deletePdf}
            >
              PDFを削除
            </span>
          </div>
        ) : (
          <p
            className="text-fz-20px text-fw-bold d-inline-block m-0"
            style={{ color: '#48A3E9', cursor: 'pointer' }}
            onClick={() => {
              inputRef.current && inputRef.current.click();
            }}
          >
            PDFで記事をアップロード
          </p>
        )}
        <p className="mt-3">
          PDFで記事を作成した場合、編集モードは使えなくなります
        </p>
        <input
          type="file"
          ref={inputRef}
          accept="application/pdf"
          onChange={updatePdf}
          className="d-none"
        />
      </div>
      {pdfUploading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '400px', width: '100%' }}
        >
          <Loader isActive={true} />
        </div>
      ) : pdf ? (
        <div className="container col-lg-8">
          <iframe src={pdf} width="100%" height="800px" />
        </div>
      ) : (
        <Contents
          foreignKeyId={blog.id}
          isApp={isApp}
          userAgent={userAgent}
          model={'Blog'}
        />
      )}
    </div>
  );
};

export default Edit;

const previewContent = (
  <button
    type="button"
    className="text-fz-13px text-fw-500 p-0 m-0 mr-2 a-button__top a-button__top--outline"
    // className="text-fz-13px text-fw-500 btn a-button__top a-button--orange text-white m-0"
    style={{ height: '35px', width: '100px' }}
  >
    詳細設定
  </button>
);

const DetailContent = ({
  publicType,
  publishDatetime,
  tags,
  setPublicType,
  handlePostDateChange,
  handleTagClick,
  handleTagsInput,
  handleDeleteButton,
  myCircle,
  pastTags,
}) => {
  return (
    <div className="container pb-4">
      {myCircle && (
        <div className="">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開範囲
          </p>
          <select
            className="form-control form-control-lg"
            value={publicType}
            onChange={(e) => setPublicType(e.target.value)}
          >
            <option value="1">全体公開</option>
            <option value="2">サークル内限定</option>
          </select>
        </div>
      )}
      <div className="">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          予約投稿
        </p>
      </div>
      <div className="">
        <input
          type="datetime-local"
          className="p-1 w-100 form-control form-control-lg"
          value={publishDatetime}
          onChange={handlePostDateChange}
        />
      </div>
      <div className="">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-0 mt-3 d-inline-block">
          カテゴリ
        </p>
      </div>
      <div className="mt-0">
        <BlogTagsInput blogTags={tags} handleTagsInput={handleTagsInput} />
      </div>
      <div>
        <p className="text-gray text-fz-small mt-1 mb-0">
          改行またはEnter Keyで登録を保存できます。
        </p>
      </div>
      {/* ここに過去使ったタグを表示する */}
      <div className="past-tags mt-2 mb-0">
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {pastTags &&
              pastTags.map((tag, index) => (
                <li
                  key={index}
                  onClick={() => handleTagClick(tag)} // タグをクリックした際にタグを追加
                  className="btn btn-outline-primary btn-outline-blue btn-sm btn-sm--expand mr-2 d-inline-block"
                  style={{
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                >
                  {tag}
                </li>
              ))}
          </ul>
        </div>
      <div className="">
        <button
          type="button"
          className="text-fz-14px text-fw-bold text-danger mb-2 mt-3 p-0 d-inline-block border-0 bg-white"
          onClick={handleDeleteButton}
        >
          このブログを削除する
        </button>
      </div>
    </div>
  );
};
